import { RISK_CATEGORIES } from '@silverfort-nodelibs/common/utils/insight';
import { SEVERITIES_INFO } from '../../../consts/Severity';
import { ListItemProps } from '@silverfort/sf-components';

const EXPOSURE_TYPES_OPTIONS: ListItemProps<string | number>[] = Object.values(RISK_CATEGORIES).map((category) => ({
    value: category.key,
    title: category.title
}));

const SEVERITY_OPTIONS: ListItemProps<number | string>[] = Object.entries(SEVERITIES_INFO).map(([_, value]) => ({
    value: value.value,
    title: value.label
}));

export { EXPOSURE_TYPES_OPTIONS, SEVERITY_OPTIONS };
